import React, {useEffect, useState} from "react";
import {useNavigate, useParams} from "react-router-dom";

const SeriesInfo = ({show}) => {
    const title = show.title;
    const description = show.description;
    const people = show.people;
    const years = show.years;
    const poster = show.poster;
    return (
        <div className="series-info">
            <img src={`${process.env.REACT_APP_STORAGE_URL}/${poster}`} alt={title} className="series-poster"/>
            <div className="series-details">
                <h1 className="series-title">{title}</h1>
                <p className="series-description">{description}</p>
                <p className="series-years">Годы выхода: {years}</p>
                <div className="series-people">
                    <p className="series-director">
                        <strong>Режиссёр:</strong> <a href={people.director.url} target="_blank"
                                                      rel="noopener noreferrer">{people.director.name}</a>
                    </p>
                    <div className="series-actors">
                        <strong>Актёры:</strong>
                        <ul>
                            {Object.entries(people.actors).map(([name, url]) => (
                                <li key={name}>
                                    <a href={url} target="_blank" rel="noopener noreferrer">{name}</a>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
};

const SeasonsPage = () => {
    const {name} = useParams();
    const navigate = useNavigate();
    const [seasons, setSeasons] = useState([]);
    const [title, setTitle] = useState("");
    const [seasonPosters, setSeasonPosters] = useState({});
    const [show, setShow] = useState(null);

    useEffect(() => {
        const fetchShowData = async () => {
            try {
                const response = await fetch(`${process.env.REACT_APP_STORAGE_URL}/info.json`);
                const data = await response.json();
                const show = data.find((show) => show.name === name);
                setShow(show);
                if (show) {
                    setTitle(show.title);
                    const seasonData = Object.entries(show.series); // Получаем пары [season, data]
                    setSeasons(seasonData);
                    setSeasonPosters(
                        seasonData.reduce((acc, [key, value]) => {
                            acc[key] = value.poster;
                            return acc;
                        }, {})
                    );

                    // Сохраняем сериал в память для Header
                    localStorage.setItem("currentShow", JSON.stringify({name}));
                }
            } catch (error) {
                console.error("Error fetching show data:", error);
            }
        };
        fetchShowData();
    }, [name]);

    const handleSeasonClick = (season) => {
        navigate(`/player/${name}/${season}`);
    };

    if (seasons.length === 0) {
        return <div>Загрузка...</div>;
    }

    return (
        <>
            {show ? <SeriesInfo {...{show: show}}/> : null}

            <div className="home-page">
                <div style={{padding: "20px"}}>
                    <h1>Все сезоны</h1>
                    <div className="series-container">
                        {seasons.map(([season, data]) => (
                            <div onClick={() => handleSeasonClick(season)}
                                 key={season}
                                 className="series-card"
                            >
                                <img
                                    src={`${process.env.REACT_APP_STORAGE_URL}/${data.poster}`}
                                    alt={`Сезон ${season}`}
                                    style={{width: "100%", borderRadius: "10px"}}
                                />
                                <div className="season-info">
                                    <span>Сезон {season.replaceAll('s', '')}</span>
                                    <span>{data.year}</span>
                                </div>

                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </>
    );
};

export default SeasonsPage;
